import { css } from "@emotion/css";

export const chapterPageStyles = {
  content: css({
    whiteSpace: 'pre-line',
  }),
};